<template>
    <div class="table-last-updated-component" v-if="lastUpdated">
        <p>Last updated: {{ lastUpdated }}</p>
    </div>
</template>

<script>
    import {mixinDatesHandler} from '@/mixins/dates-handler';

    export default {
        name: 'TableLastUpdatedFooter',

        props: {
            date: {
                default: null,
                type: String,
            },
            fromFormat: {
                default: null,
                type: String
            },
            format: {
                default: 'DD MMM YYYY HH:mm:ss',
                type: String,
            },
            showTimeZone: {
                default: true,
                type: Boolean,
            }
        },

        mixins: [mixinDatesHandler],

        computed: {
            lastUpdated() {
                if (!this.date) {
                    return null;
                }

                if (this.from) {
                  return this.$moment(this.date, this.fromFormat).format(this.format);
                }

                if (this.showTimeZone) {
                    return `${this._mixinDateHandler_ApiResponseDateTimeToFormat(this.date, this.format, true)}
                            ${this._mixinDateHandler_GetTimeZoneAbbr()}`;
                }

                return `${this._mixinDateHandler_ApiResponseDateTimeToFormat(this.date, this.format, true)}`;
            }
        }
    }
</script>

<style scoped lang="scss">
    .table-last-updated-component {
        width: 100%;

        p {
            font-size: 14px;
            font-style: oblique;
        }
    }
</style>
